module.exports = __webpack_public_path__ + "static/media/Aditya_Raskar.fddd70b0.jpg";